/**
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema Golden Sisters
 * Arquivo: src/components/ui/Modal.js
 * Versão: 2.2 (UI FIX: Removido h-full para evitar “espaço morto” em conteúdos curtos; mantida altura máxima e rolagem apenas quando necessário.)
 * Data: 31 de dezembro de 2025
 * Responsável pela Alteração: ChatGPT (conforme Protocolo)
 */
import React from 'react';
import { X } from 'lucide-react';

const Modal = ({ onClose, title, children, size = '4xl' }) => {
    // Define classes de tamanho para max-width, para controlar a largura do modal
    const sizeClasses = {
        'sm': 'max-w-sm',
        'md': 'max-w-md',
        'lg': 'max-w-lg',
        'xl': 'max-w-xl',
        '2xl': 'max-w-2xl',
        '3xl': 'max-w-3xl',
        '4xl': 'max-w-4xl',
        '5xl': 'max-w-5xl',
        '6xl': 'max-w-6xl',
        '7xl': 'max-w-7xl'
    };

    // Overlay com rolagem do próprio fundo quando necessário (telas menores)
    const overlayClasses =
        "fixed inset-0 bg-black bg-opacity-70 z-[99999] flex justify-center items-center p-4 overflow-y-auto";

    // CONSERTO: remover h-full.
    // Mantém max-h para não estourar a viewport, mas deixa a altura se ajustar ao conteúdo.
    const modalContainerClasses =
        `bg-brand-dark rounded-lg shadow-2xl border border-gray-700 w-full ${sizeClasses[size]} flex flex-col max-h-[90vh]`;

    return (
        <div className={overlayClasses} onClick={onClose}>
            <div className={modalContainerClasses} onClick={(e) => e.stopPropagation()}>
                {/* Cabeçalho do Modal */}
                <div className="flex justify-between items-center p-4 border-b border-gray-700 flex-shrink-0">
                    <h3 className="text-xl font-semibold text-brand-gold">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-brand-gold p-1 rounded-full hover:bg-gray-700 transition-colors"
                        aria-label="Fechar modal"
                    >
                        <X className="h-6 w-6" />
                    </button>
                </div>

                {/* Corpo do Modal */}
                {/* Scroll só aparece quando o conteúdo exceder a altura máxima do modal */}
                <div className="p-6 overflow-y-auto">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
